import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function RAFAdvance() {
  const [phoneNumber, setPhonenumber] = useState("");
  const [nameSurename, setNameSurename] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [settled, setSetteld] = useState("");
  const [attornetFirm, setAttorneyFirm] = useState("");
  const [attorneyName, setAttorneyName] = useState("");
  const navigate = useNavigate();

  function sendMail() {
    console.log("Sending Email");
    console.log(message);

    if (nameSurename && email && phoneNumber) {
      localStorage.setItem("name", nameSurename);
      localStorage.setItem("email", email);
      localStorage.setItem("tel", phoneNumber);
      localStorage.setItem("message", message);
      localStorage.setItem("settled", settled);
      localStorage.setItem("attorneyFirm", attornetFirm);
      localStorage.setItem("attorneyName", attorneyName);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name & Surname: ${nameSurename} <br/> Phone: ${phoneNumber} <br/> Email: ${email} <br/> Is your RAF claim settled: ${settled} <br/> Attornet Firm: ${attornetFirm} <br/> Attorney Name: ${attorneyName}`
      );
      formData.append("subject", "RAF Bridging Finance");
      formData.append("to", "apply@webridge.co.za");

      // Attach a file if there is one
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment">
      if (fileInput && fileInput.files.length > 0) {
        formData.append("attachment", fileInput.files[0]);
        formData.append("attachmentTwo", fileInput.files[0]);
      }

      axios
        .post("https://email-sender-lovat.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/ThankYou");
    }

    return alert("Fill in all fields to continue");
  }

  return (
    <>
      <form action="">
        <input
          className=" form-control"
          type="text"
          id="name"
          placeholder="Name & Surname"
          value={nameSurename}
          onChange={(e) => setNameSurename(e.target.value)}
        />

        <input
          className=" form-control"
          type="tel"
          id="tel"
          placeholder="Phone number"
          value={phoneNumber}
          onChange={(e) => setPhonenumber(e.target.value)}
        />

        <input
          className=" form-control"
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Adress"
        />
        <p>Is your RAF claim settled? *</p>
        <select
          id="settled"
          className=" form-control form-select"
          value={settled}
          onChange={(e) => setSetteld(e.target.value)}
        >
          <option>---</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
        <input
          className=" form-control"
          type="text"
          id="attorneyFirm"
          value={attornetFirm}
          onChange={(e) => setAttorneyFirm(e.target.value)}
          placeholder="Attorney Firm that represents you:"
        />

        <input
          className=" form-control"
          type="text"
          id="attorneyName"
          value={attorneyName}
          onChange={(e) => setAttorneyName(e.target.value)}
          placeholder="Your attorney's name (Name & Surname):"
        />

        <button onClick={() => sendMail()} className=" btn btn-primary">
          Submit
        </button>
      </form>
    </>
  );
}

export default RAFAdvance;
